import { useGetIdentity, useOne } from "@refinedev/core";
import React, { PropsWithChildren } from "react";
import * as Sentry from "@sentry/react";
import { DrawerProvider } from "../../context/drawer.context";
import { SidebarProvider } from "../../context/sidebar-context";
import { AssociationUserShowProvider } from "../../context/user-show.context";
import { useWindowDimensions } from "../../hooks";
import { ResourceIdentifier } from "../../resources";
import { Association, AssociationUser, User } from "../../sdk";
import { Menu } from "../menu";
import { Sidebar } from "../sidebar/sidebar";
import GlobalDrawer from "../ui/global-drawer";
import {LayoutMessage} from "./layout-message";

export const Layout: React.FC<PropsWithChildren> = ({ children }) => {
  const { data: identity, isLoading: isIdentityLoading, isError, error} = useGetIdentity<User>();
  const { width, height } = useWindowDimensions();

  const { data: associationUserData } = useOne<AssociationUser>({
    resource: ResourceIdentifier.AssociationUser,
    id: identity?.associationUsers?.[0]?.id,
    meta: {
      associationId: identity?.associationUsers?.[0]?.associationId,
    },
  });

  const { data: associationData } = useOne<Association>({
    resource: ResourceIdentifier.Association,
    // id: identity?.associationUsers?.[0]?.associationId,
    id: identity?.associationUsers?.[0]?.associationId,
  });
  
  if (isError) {
    Sentry.captureException(error);

    return <LayoutMessage>
      <h1 className="text-xl font-bold mb-4">
        An error occured while loading the application (E001).
      </h1>
      <p className="text-lg mb-4">
        Please contact your association administrator to get access to
        this application.
      </p>
    </LayoutMessage>
  }

  if (isIdentityLoading) {
    return null
  }

  return (
    <main
      style={{ height }}
      className={"max-h-screen overflow-x-hidden relative bg-primary"}
    >
      {!!identity?.associationUsers?.[0] &&
        associationUserData?.data &&
        associationData?.data && (
          <AssociationUserShowProvider
            associationUser={{
              ...associationUserData?.data,
              association: associationData?.data,
              user: associationUserData.data.user,
            }}
          >
            <SidebarProvider>
              <DrawerProvider>
                <GlobalDrawer />
                <div className="layout flex flex-col h-full">
                  <Sidebar />
                  <div className={"absolute w-full h-full"}>
                    <Menu />
                  </div>
                  {/*<Breadcrumb />*/}
                  {children}
                </div>
              </DrawerProvider>
            </SidebarProvider>
          </AssociationUserShowProvider>
        )}
      {!identity?.associationUsers?.[0] && (
        <LayoutMessage>
          <h1 className="text-xl font-bold mb-4">
            You are not associated with any association
          </h1>
          <p className="text-lg mb-4">
            Please contact your association administrator to get access to
            this application.
          </p>
        </LayoutMessage>
      )}
    </main>
  );
};
